import React from 'react';
import { FormattedMessage, intlShape, injectIntl } from 'react-intl';

import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import IconButton from '@material-ui/core/IconButton';
import TextField from '@material-ui/core/TextField';

import correct_bg from '../../../images/progress.png';
import warning_bg from '../../../images/warning.png';
import error_bg from '../../../images/error.png';

import { BlueCloseIcon } from '../../../images/icons/WrapSvg';
import { formatDateTime, percentage } from '../../../functions/time';

import MultiSelectInput from '../../inputs/SelectInput';

class DecreasePopup extends React.Component {
    state = {
        product: this.props.info ? this.props.info : {},
        units: 0,
        message: '',
        disabled: false
    };

    handleChangeProces = (event) => {
        this.setState({ products: event });
    };


    handleChangeMessage = (event) => {
        this.setState({ message: event });
    };

    handleMinus = (event) => {
        if (this.state.units > 0) this.setState({ units: this.state.units - 1 });
    };

    handlePlus = (event) => {
        if (this.state.units < this.state.product.cantidad)
            this.setState({ units: this.state.units + 1 });
    };

    handleChangeClick = (add) => (event) => {
        const { units } = this.state;
        const value = parseInt(units.toString().concat(add), 10);
        this.setState({ units: value });
    };

    handleRemoveUnits = (event) => {
        this.setState({ units: 0 });
    }

    handleChange = (event) => {
        this.setState({ [event.target.name]: event.target.value });
    };

    handleSummit = (event) => {
        const { product, units, message } = this.state;
        this.setState({ disabled: true });
        this.props
            .decrease({
                idLocal: this.props.id,
                idProduccion: product.id,
                merma: units,
                motivo: message.value,
            })
            .then(() => this.props.handleClose('decrease', false))
            .catch((error) => this.props.handleClose('decrease', error.message));
    };

    render() {
        const { product, units, message, disabled } = this.state;
        const { handleClose, intl } = this.props;
        return (
            <Dialog
                onClose={() => handleClose('decrease', false)}
                aria-labelledby="customized-dialog-title"
                disableBackdropClick
                open={true}
                classes={{
                    paper: 'xhef_waste_popup',
                }}
            >
                <div className="flex_full_column">
                    <div className="flex_auto_row xhef_waste_popup_header align_center">
                        <IconButton
                            aria-label="Close"
                            className={''}
                            onClick={() => handleClose('decrease', false)}
                        >
                            <BlueCloseIcon />
                        </IconButton>
                        <div className="flex_full_row center barlowsemicondensed_bold">
                            <FormattedMessage id="xhef_popup_decrease_title" />
                        </div>
                    </div>
                    <div className="flex_auto_row">
                        <div className="flex_full_column padding_borders">
                            <div className="flex_auto_row align_center">
                                <div className="flex_full_column">
                                    <div className="flex_full_row barlowsemicondensed_bold c_grey_blue uppercase">
                                        {product.nomProducto}
                                    </div>
                                    <div className="flex_full_row barlow_medium_tree_local c_grey_blue padding_top_3">
                                        {formatDateTime(product.caducidad)}
                                    </div>
                                </div>
                                <div className="flex_auto_column">
                                    <div className="barlowcondensed_light_percentage c_dark_grey_blue">
                                        {product.disponible + '/' + product.nombre}
                                    </div>
                                </div>
                            </div>
                            <div className="flex_auto_row align_center margin_top_32">
                                <MultiSelectInput
                                    defaultValue={message}
                                    placeHolder={intl.formatMessage({
                                        id: 'xhef_popup_message_title',
                                    })}
                                    isNotSearchable
                                    options={[
                                        {
                                            label: intl.formatMessage({ id: 'xhef_popup_waste_message_expiraded' }),
                                            value: 0,
                                        },
                                        {
                                            label: intl.formatMessage({ id: 'xhef_popup_waste_message_missing' }),
                                            value: 1,
                                        },
                                        {
                                            label: intl.formatMessage({ id: 'xhef_popup_waste_message_temperature_control' }),
                                            value: 2,
                                        },
                                        {
                                            label: intl.formatMessage({ id: 'xhef_popup_waste_message_fail' }),
                                            value: 3,
                                        },
                                        {
                                            label: intl.formatMessage({ id: 'xhef_popup_waste_message_customer' }),
                                            value: 4,
                                        },
                                        {
                                            label: intl.formatMessage({ id: 'xhef_popup_waste_message_fall_down' }),
                                            value: 5,
                                        },
                                        {
                                            label: intl.formatMessage({ id: 'xhef_popup_waste_message_other' }),
                                            value: 6,
                                        }
                                    ]}
                                    onChange={this.handleChangeMessage}
                                />
                            </div>
                            <div
                                className="flex_auto_row align_center margin_bottom_24 margin_top_12"
                                style={{
                                    flex: '0 1 50%',
                                    backgroundColor: '#d7dfe6',
                                    backgroundSize:
                                        percentage(
                                            product.caducidad,
                                            this.props.xef_reference_time,
                                            product.finproduccion,
                                        ) + '% auto',
                                    backgroundRepeat: 'repeat-y',
                                    backgroundImage:
                                        'url(' +
                                        (product.caducidad < this.props.xef_reference_time
                                            ? error_bg
                                            : this.props.xef_reference_time > product.avisocaducidad
                                                ? warning_bg
                                                : correct_bg) +
                                        ')',
                                    backgroundPositionY: 'center',
                                }}
                            />
                            <div className="flex_auto_row margin_top_32 align_center">
                                {
                                    <TextField
                                        disabled={true}
                                        fullWidth
                                        name={'units'}
                                        id={'units'}
                                        label={intl.formatMessage({
                                            id: 'decrease_table_decrease',
                                        })}
                                        value={product.merma}
                                        type="number"
                                        InputProps={{
                                            className:
                                                'barlowcondensed_regular c_black bg_dark_grey_blue_8',
                                        }}
                                        //eslint-disable-next-line
                                        inputProps={{
                                            pattern: '[0-9]*',
                                            style: { textAlign: 'center' },
                                        }}
                                        className="text_align_center padding_right_12"
                                    />
                                }

                                <TextField
                                    required
                                    fullWidth
                                    name={'units'}
                                    id={'units'}
                                    label={intl.formatMessage({
                                        id: 'xhef_popup_waste_units_title',
                                    })}
                                    value={units}
                                    type="number"
                                    InputProps={{
                                        className: 'barlowcondensed_regular c_black',
                                    }}
                                    //eslint-disable-next-line
                                    inputProps={{
                                        pattern: '[0-9]*',
                                        style: { textAlign: 'center' },
                                    }}
                                    onChange={this.handleChange}
                                    className="text_align_center"
                                />
                            </div>
                            <div className="flex_auto_row ">
                                <div className="flex_full_column">
                                    <div className="flex_full_row center margin_top_32 ">
                                        <Button
                                            onClick={this.handleChangeClick(0)}
                                            color="primary"
                                            variant="outlined"
                                            className="xef_calculator_button barlowsemicondensed_regular no_uppercase c_bluish margin_right_6"
                                        >
                                            0
                                        </Button>
                                        <Button
                                            onClick={this.handleChangeClick(1)}
                                            color="primary"
                                            variant="outlined"
                                            className="xef_calculator_button barlowsemicondensed_regular no_uppercase c_bluish margin_right_6"
                                        >
                                            1
                                        </Button>
                                        <Button
                                            onClick={this.handleChangeClick(2)}
                                            color="primary"
                                            variant="outlined"
                                            className="xef_calculator_button barlowsemicondensed_regular no_uppercase c_bluish margin_right_6"
                                        >
                                            2
                                        </Button>
                                        <Button
                                            onClick={this.handleChangeClick(3)}
                                            color="primary"
                                            variant="outlined"
                                            className="xef_calculator_button barlowsemicondensed_regular no_uppercase c_bluish margin_right_6"
                                        >
                                            3
                                        </Button>
                                        <Button
                                            onClick={this.handleChangeClick(4)}
                                            color="primary"
                                            variant="outlined"
                                            className="xef_calculator_button barlowsemicondensed_regular no_uppercase c_bluish margin_right_6"
                                        >
                                            4
                                        </Button>
                                    </div>
                                    <div className="flex_full_row center margin_top_32 ">
                                        <Button
                                            onClick={this.handleChangeClick(5)}
                                            color="primary"
                                            variant="outlined"
                                            className="xef_calculator_button barlowsemicondensed_regular no_uppercase c_bluish margin_right_6"
                                        >
                                            5
                                        </Button>
                                        <Button
                                            onClick={this.handleChangeClick(6)}
                                            color="primary"
                                            variant="outlined"
                                            className="xef_calculator_button barlowsemicondensed_regular no_uppercase c_bluish margin_right_6"
                                        >
                                            6
                                        </Button>
                                        <Button
                                            onClick={this.handleChangeClick(7)}
                                            color="primary"
                                            variant="outlined"
                                            className="xef_calculator_button barlowsemicondensed_regular no_uppercase c_bluish margin_right_6"
                                        >
                                            7
                                        </Button>
                                        <Button
                                            onClick={this.handleChangeClick(8)}
                                            color="primary"
                                            variant="outlined"
                                            className="xef_calculator_button barlowsemicondensed_regular no_uppercase c_bluish margin_right_6"
                                        >
                                            8
                                        </Button>
                                        <Button
                                            onClick={this.handleChangeClick(9)}
                                            color="primary"
                                            variant="outlined"
                                            className="xef_calculator_button barlowsemicondensed_regular no_uppercase c_bluish margin_right_6"
                                        >
                                            9
                                        </Button>
                                    </div>
                                </div>
                                <Button
                                    onClick={this.handleRemoveUnits}
                                    color="primary"
                                    variant="outlined"
                                    className="xef_calculator_button barlowsemicondensed_regular no_uppercase c_bluish margin_right_6 margin_top_32"
                                >
                                    {
                                        intl.formatMessage({
                                            id: 'remove',
                                        })
                                    }
                                </Button>
                            </div>
                            {/*
                            <div className="flex_full_row margin_top_32 align_center">
                                <Button
                                    onClick={this.handleMinus.bind(this)}
                                    variant="contained"
                                    disabled={units <= 0}
                                    className={
                                        'flex_full_row bg_white padding_borders xhef_waste_popup_button_negative'
                                    }
                                    classes={{
                                        disabled: 'xhef_waste_popup_button_negative_disabled',
                                    }}
                                >
                                    <MinusIcon className={units > 0 ? 'c_bluish' : 'c_white'} />
                                </Button>
                                <Button
                                    disabled={units >= this.state.product.disponible}
                                    onClick={this.handlePlus.bind(this)}
                                    variant="contained"
                                    className={
                                        'flex_full_row bg_pea padding_borders xhef_waste_popup_button_positive'
                                    }
                                    classes={{
                                        disabled: 'xhef_waste_popup_button_positive_disabled',
                                    }}
                                >
                                    <AddIcon className="c_white" />
                                </Button>
                            </div>
                                */}
                        </div>
                    </div>
                    <div className="flex_auto_row center xhef_waste_popup_footer">
                        <Button
                            disabled={units < 0 || units > this.state.product.disponible || disabled || !message}
                            variant="contained"
                            color="primary"
                            className={'flex_full_row barlow_semibold padding_borders'}
                            onClick={this.handleSummit}
                        >
                            <FormattedMessage id="xhef_popup_decrease_button_title" />
                        </Button>
                    </div>
                </div>
            </Dialog>
        );
    }
}

DecreasePopup.propTypes = {
    intl: intlShape.isRequired,
};

export default injectIntl(DecreasePopup);



// WEBPACK FOOTER //
// ./src/components/complex/xhef/DecreasePopup.js